import styled from 'styled-components';

export const StyledDimensionName = styled.div`
    font-size: 15px;
    font-weight: 300;
    color: var(--color-gray-lightest);
`;
